import {err, ok, ValidationError} from 'framework';
import type {Result, Validator} from 'framework';
import {z} from 'zod';
import {betterAuthErrorSchema} from './better-auth-response.schemas';

const requestPasswordResetResponseSchema = z.object({
  data: z.unknown().nullish(),
  error: betterAuthErrorSchema.nullish(),
});

export type BetterAuthRequestPasswordResetResponse = z.output<
  typeof requestPasswordResetResponseSchema
>;

export class BetterAuthRequestPasswordResetResponseValidator
  implements Validator<BetterAuthRequestPasswordResetResponse>
{
  readonly standardSchema = requestPasswordResetResponseSchema;

  validate(value: unknown): Result<BetterAuthRequestPasswordResetResponse, ValidationError> {
    const parsed = this.standardSchema.safeParse(value);

    if (!parsed.success) {
      return err(
        new ValidationError(
          parsed.error.issues[0]?.message ??
            'Unexpected request-password-reset response shape.',
        ),
      );
    }

    return ok(parsed.data);
  }
}
